module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0241.8d063ca1.jpg";